
if (!customElements.get('range-progress')) {
  class RangeProgress extends HTMLElement {
    constructor() {
      super();
      this.line = this.firstElementChild;
      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.line.style.width = `${this.getAttribute('data-width')}%`;
          }
        });
      }, options);

      this.observer.observe(this.line);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('range-progress', RangeProgress);
}
